module.exports = "/assets/data/4bf4700b40a3ac2641d8fe361df22719-CM17.data.json";